"use client";
import "./collapse_panel.scss";
import React, { useEffect } from "react";
import classnames from "classnames";

type RenderFunction = () => React.ReactNode;

export interface Props {
  open?: boolean;
  id?: string;
  children: React.ReactNode | RenderFunction;
}

export function CollapsePanel({
  open,
  id,
  children,
}: Props): React.ReactElement {
  const ref = React.useRef<HTMLDivElement>(null);

  function toggleOverflow(): void {
    const container = ref.current;
    if (container !== null) {
      if (container.classList.contains("collapse-panel--open")) {
        container.setAttribute("style", "--collapse-panel-overflow: visible");
      } else {
        container.setAttribute("style", "--collapse-panel-overflow: hidden");
      }
    }
  }

  useEffect(() => {
    toggleOverflow();
  }, []);

  return (
    <div
      ref={ref}
      className={classnames("collapse-panel", { "collapse-panel--open": open })}
      onTransitionEnd={toggleOverflow}
      id={`${id}-collapse-panel`}
    >
      <div className="collapse-panel__content">
        {typeof children === "function" ? children() : children}
      </div>
    </div>
  );
}
